import { createFileRoute } from "@tanstack/react-router";

import { Namespace } from "@/features/publisher";

export const Route = createFileRoute("/publisher/namespace")({
  component: Namespace,
});
